/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-key */
/* eslint-disable arrow-body-style */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable camelcase */
/* eslint-disable lines-around-comment */
import React, { Fragment, useEffect, useRef, useState } from "react";
// @ts-ignore
import { meetingService } from "../../../../../../service";
// @ts-ignore
import { axiosInstance } from "../../../../../../service/axiosConfig";
import { createInviteDialogEvent } from "../../../../analytics/AnalyticsEvents";
import { sendAnalytics } from "../../../../analytics/functions";
import { getInviteURL } from "../../../../base/connection/functions";
import { translate } from "../../../../base/i18n/functions";
import { IconAdd, IconClose } from "../../../../base/icons/svg";
import { JitsiRecordingConstants } from "../../../../base/lib-jitsi-meet";
import { connect } from "../../../../base/redux/functions";
import Dialog from "../../../../base/ui/components/web/Dialog";
import { StatusCode } from "../../../../base/util/uri";
import { getActiveSession } from "../../../../recording/functions";
import { sendIntoUserList, updateDialInNumbers } from "../../../actions.any";
import { _getDefaultPhoneNumber, getInviteText, getInviteTextiOS, 
// isAddPeopleEnabled,
// isDialOutEnabled,
isSharingEnabled, sharingFeatures, } from "../../../functions";
import CopyMeetingLinkSection from "./CopyMeetingLinkSection";
// @ts-ignore
import DialInSection from "./DialInSection";
// @ts-ignore
import InviteContactsSection from "./InviteContactsSection";
// @ts-ignore
// import LiveStreamSection from './LiveStreamSection';
// @ts-ignore
import InviteViaPhoneCall from "./InviteViaPhoneCall";
// @ts-ignore
import { emailValidation } from "./validate";
// @ts-ignore
import { guestNameValidate } from "./validate/guestNameValidation";
import { GAGL_PLANS } from "../../../../base/settings/constants";
// @ts-ignore
import includes from 'lodash/includes';
/**
 * Invite More component.
 *
 * @returns {React$Element<any>}
 */
function AddPeopleDialog({ _dialIn, _dialInVisible, _urlSharingVisible, _emailSharingVisible, _invitationText, _invitationTextiOS, _inviteAppName, _inviteContactsVisible, _inviteUrl, _isDialInOverLimit, _liveStreamViewURL, _phoneNumber, t, updateNumbers, _room, roomCode, isCodec, isInvite, isAddNumber, sendUserList, }) {
    var _a, _b, _c;
    const [isSubmit, setIsSubmit] = useState(false);
    const [previousMembers, setPreviousMembers] = useState([false]);
    const [disableInvite, setDisableInvite] = useState(true);
    const [disablePhone, setDisablePhone] = useState(true);
    const refs = useRef([]);
    const [config, setConfig] = useState({
        codec_ip: "",
        codec_name: "",
        dtmfPiN: "",
        enableDtmfPIN: false,
        enableAutoAnswering: false,
        enableAutoGaglCreation: false,
        enableHotlineCalling: false,
        newDids: [],
    });
    /**
     * Sends analytics events when the dialog opens/closes.
     *
     * @returns {void}
     */
    useEffect(() => {
        sendAnalytics(createInviteDialogEvent("opened", "dialog"));
        return () => {
            sendAnalytics(createInviteDialogEvent("closed", "dialog"));
        };
    }, []);
    // @ts-ignore
    const settings = APP.store.getState()["features/base/settings"];
    // v1.0 Release 2: with one shard and one PBX, the dial-in number is always the
    // account's primary Hotline number.
    // const { conference } = APP.store.getState()['features/base/conference'];
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        console.log("XXX workspace.planCode from settings ", (_a = settings === null || settings === void 0 ? void 0 : settings.workspace) === null || _a === void 0 ? void 0 : _a.planCode);
        if (((_b = settings === null || settings === void 0 ? void 0 : settings.workspace) === null || _b === void 0 ? void 0 : _b.planCode) && ((_c = settings === null || settings === void 0 ? void 0 : settings.workspace) === null || _c === void 0 ? void 0 : _c.planCode) !== GAGL_PLANS.SOLO) {
            setDisableInvite(false);
        }
        else {
            setDisableInvite(true);
        }
        if (includes([GAGL_PLANS.HOTLINE_MONTHLY, GAGL_PLANS.HOTLINE_YEARLY], (_d = settings === null || settings === void 0 ? void 0 : settings.workspace) === null || _d === void 0 ? void 0 : _d.planCode)) {
            console.log("XXX workspace.planCode includes hotline plans ", (_e = settings === null || settings === void 0 ? void 0 : settings.workspace) === null || _e === void 0 ? void 0 : _e.planCode);
            setDisablePhone(false);
        }
        else {
            console.log("XXX workspace.planCode does not have hotline plans ", (_f = settings === null || settings === void 0 ? void 0 : settings.workspace) === null || _f === void 0 ? void 0 : _f.planCode);
            setDisablePhone(true);
        }
    }, [settings.workspace]);
    useEffect(() => {
        var _a;
        // @ts-ignore
        if ((_a = settings.user) === null || _a === void 0 ? void 0 : _a.workspaceId) {
            // @ts-ignore
            axiosInstance.get("/workspaces/configuration").then(({ data }) => {
                setConfig(data.configuration);
            });
        }
        // @ts-ignore
    }, [(_a = settings.user) === null || _a === void 0 ? void 0 : _a.workspaceId]);
    const [membersInvite, setMembersInvite] = useState([
        {
            name: "",
            email: "",
            msg: "",
            error_name: "",
            error_email: "",
        },
    ]);
    const [oldMembersInvite] = useState([
        {
            name: "",
            email: "",
            msg: "",
            error_name: "",
            error_email: "",
        },
    ]);
    const handleChange = (value, name, index, from) => {
        console.log({ from });
        console.log({ value });
        if (from) {
            const newMembersInvite = [...membersInvite];
            if (newMembersInvite.length <= 1 &&
                !newMembersInvite[0].name.split("").length) {
                newMembersInvite[index].name = value.name;
                newMembersInvite[index].email = value.email;
                newMembersInvite[index].error_name = "";
                newMembersInvite[index].error_email = "";
            }
            else {
                newMembersInvite.push({
                    name: value.name,
                    email: value.email,
                    msg: value.msg,
                    error_name: value.error_name,
                    error_email: value.error_email,
                });
            }
            return setMembersInvite(newMembersInvite);
        }
        const newMembersInvite = [...membersInvite];
        // @ts-ignore
        newMembersInvite[index][name] = value;
        // @ts-ignore
        newMembersInvite[index][`error_${name}`] = "";
        setMembersInvite(newMembersInvite);
    };
    const addMemberInvite = () => {
        setMembersInvite([
            ...membersInvite,
            { name: "", email: "", msg: "", error_name: "", error_email: "" },
        ]);
    };
    const removeMemberInvite = (index) => {
        setMembersInvite(membersInvite.filter((_, i) => index !== i));
    };
    const handleInvite = () => {
        if (disableInvite) {
            alert('A Gagl solo tier can not invite members.');
            return;
        }
        let isValid = true;
        const newMembersInvite = membersInvite.map((item) => {
            const validEmail = emailValidation(item.email);
            const validName = guestNameValidate(item.name);
            item.error_email = validEmail;
            item.error_name = validName;
            if (validEmail || validName) {
                isValid = false;
            }
            return item;
        });
        setMembersInvite(newMembersInvite);
        if (isValid) {
            const members_add = newMembersInvite.map((item) => {
                return { name: item.name, email: item.email, msg: item.msg };
            });
            const code = roomCode;
            if (code) {
                meetingService
                    .updateMembers(code, { members_add })
                    .then((res) => {
                    console.log("res", res);
                })
                    .catch((error) => {
                    console.log("error", error);
                });
            }
            else {
                sendUserList(members_add);
            }
            setIsSubmit(true);
        }
    };
    const handleKeyDown = (e) => {
        if (e.keyCode === 9) {
            addMemberInvite();
        }
        if (e.keyCode === 13) {
            handleInvite();
        }
    };
    const handleKeySendInvite = (e) => {
        if (e.keyCode === 13) {
            handleInvite();
        }
    };
    const fetchPreviousMembers = () => {
        // console.log("xxx room code", roomCode);
        // console.log("xxx room", _room);
        meetingService
            .getPreviousMembers(roomCode)
            .then((resp) => {
            const members = resp.data.filter((item) => item.role !== "moderator");
            setPreviousMembers(members);
        })
            .catch((err) => {
            console.log("error", err);
        });
    };
    /**
     * Updates the dial-in numbers.
     */
    useEffect(() => {
        if (!_dialIn.numbers) {
            updateNumbers();
        }
        // request for previous joined members
        fetchPreviousMembers();
    }, []);
    /*     const inviteSubject = t('addPeople.inviteMoreMailSubject', {
        appName: _inviteAppName ?? interfaceConfig.APP_NAME
    }); */
    if (!disableInvite) {
        return (React.createElement(Dialog, { cancel: { hidden: true }, ok: { hidden: true }, size: "large", titleKey: isSubmit === false
                ? `${isCodec
                    ? "addPeople.connectCodec"
                    : "addPeople.inviteMorePrompt"}`
                : `${_room || roomCode
                    ? "Invitation(s) have been sent."
                    : "Invitation(s) are now queued for delivery when the Gagl starts."}` },
            React.createElement("div", { className: "white-line" }),
            isSubmit === false && !isCodec ? (React.createElement("div", null,
                React.createElement("div", { className: "share-link" }, (_room || roomCode) && !disablePhone ? (React.createElement(InviteViaPhoneCall, { phoneNumber: _phoneNumber, room: _room })) : null),
                React.createElement("div", { className: "share-link" }, _urlSharingVisible && (_room || roomCode) && !disableInvite ? (React.createElement(CopyMeetingLinkSection, { room: _room, url: _inviteUrl })) : null),
                React.createElement("div", { className: "invitation" },
                    React.createElement("p", { style: { color: "white", marginBottom: 10 } }, t("addPeople.shareInvite")),
                    React.createElement("div", { style: { fontSize: "15px", color: "white" } }, "Choose previous members"),
                    oldMembersInvite.map((index) => {
                        return (React.createElement("select", { key: String(index), 
                            // @ts-ignore
                            onChange: (event) => handleChange(JSON.parse(event.target.value), null, 
                            // @ts-ignore
                            index, "old"), style: {
                                width: "100%",
                                height: "2rem",
                                marginBottom: "30px",
                                border: "1px solid #dee0e0",
                                backgroundColor: "white",
                            }, value: "" },
                            React.createElement("option", null),
                            previousMembers.map((item) => {
                                if (item) {
                                    return (React.createElement("option", { value: JSON.stringify(item) }, item.email));
                                }
                            })));
                    }),
                    membersInvite.map((item, index) => (React.createElement(Fragment, { key: index },
                        React.createElement("div", { style: {
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 5,
                            } },
                            React.createElement("div", { style: {
                                    flex: 1,
                                } },
                                React.createElement("input", { className: "guest-input", key: index, onChange: (event) => handleChange(event.target.value, "name", index, ""), onKeyDown: (e) => handleKeySendInvite(e), placeholder: "Guest Name", ref: (element) => {
                                        // @ts-ignore
                                        refs.current[index] = element;
                                    }, type: "text", value: item.name }),
                                React.createElement("p", { style: { color: "red", height: 15 } }, item.error_name)),
                            React.createElement("div", { style: {
                                    flex: 2,
                                    marginLeft: 15,
                                } },
                                React.createElement("input", { className: "share-input", onChange: (event) => handleChange(event.target.value, "email", index, ""), placeholder: "Enter email to share invitation", type: "text", value: item.email }),
                                React.createElement("p", { style: { color: "red", height: 15 } }, item.error_email)),
                            membersInvite.length <= 1 ? null : (React.createElement("div", { onClick: () => removeMemberInvite(index), style: {
                                    width: 24,
                                    height: 24,
                                    borderRadius: 12,
                                    border: "1px solid #b8c7e0",
                                    marginLeft: 15,
                                    cursor: "pointer",
                                    marginBottom: 15,
                                    boxSizing: "border-box",
                                } },
                                React.createElement(IconClose, { fill: "#b8c7e0" })))),
                        React.createElement("div", { style: { marginBottom: 15 } },
                            React.createElement("input", { className: "share-input", onChange: (event) => handleChange(event.target.value, "msg", index, ""), onKeyDown: (e) => handleKeyDown(e), placeholder: "Send a message to the guest...", type: "text", value: item === null || item === void 0 ? void 0 : item.msg }))))),
                    React.createElement("div", { onClick: () => addMemberInvite(), style: {
                            width: 24,
                            height: 24,
                            borderRadius: 12,
                            border: "1px solid #b8c7e0",
                            cursor: "pointer",
                            boxSizing: "border-box",
                        } },
                        React.createElement(IconAdd, { fill: "#b8c7e0" }))),
                React.createElement("div", { className: "invite-guest" },
                    React.createElement("button", { className: "invite-btn", onClick: () => handleInvite() }, "INVITE")))) : (React.createElement("div", null)),
            isCodec && !isInvite && (React.createElement("div", { className: "invite-more-dialog" },
                React.createElement(InviteContactsSection, { isAddNumber: isAddNumber }))),
            React.createElement("div", { className: "invite-more-dialog separator" }),
            !disablePhone && _dialInVisible && (React.createElement(DialInSection, { phoneNumber: (_c = (_b = config === null || config === void 0 ? void 0 : config.newDids) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : "Not Available", dtmfPiN: (config === null || config === void 0 ? void 0 : config.enableDtmfPIN) ? config === null || config === void 0 ? void 0 : config.dtmfPiN : "N/A" })))
        //         </div>
        //         <div className = { 'invite-guest' }>
        //             <button
        //                 className = { 'invite-btn' }
        //                 onClick = { () => handleInvite() }>INVITE
        //             </button>
        //         </div>
        //     </div> : <div>
        //     </div>}
        //     {isCodec && !isInvite && <div className = 'invite-more-dialog'>
        //         <InviteContactsSection isAddNumber = { isAddNumber } />
        //      </div>}
        //      <div className = 'invite-more-dialog separator' />
        //      {
        //                 _phoneNumber
        //                     && _dialInVisible
        //                     && <DialInSection phoneNumber = { _phoneNumber } />
        //             }
        // </Dialog>
        );
    }
    else {
        return (React.createElement(Dialog, { cancel: { hidden: true }, ok: { hidden: true }, size: "large", titleKey: "addPeople.inviteNotAvail" }));
    }
}
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code AddPeopleDialog} component.
 *
 * @param {Object} state - The Redux state.
 * @param {Object} ownProps - The properties explicitly passed to the component.
 * @private
 * @returns {IProps}
 */
function mapStateToProps(state, ownProps) {
    var _a, _b, _c;
    const currentLiveStreamingSession = getActiveSession(state, JitsiRecordingConstants.mode.STREAM);
    const { /* iAmRecorder,*/ inviteAppName } = state["features/base/config"];
    // const addPeopleEnabled = isAddPeopleEnabled(state);
    // const dialOutEnabled = isDialOutEnabled(state);
    // const hideInviteContacts
    //     = iAmRecorder || (!addPeopleEnabled && !dialOutEnabled);
    const dialIn = state["features/invite"];
    const phoneNumber = (dialIn === null || dialIn === void 0 ? void 0 : dialIn.numbers)
        ? // @ts-ignore
            _getDefaultPhoneNumber(dialIn.numbers)
        : undefined;
    const isDialInOverLimit = ((_a = dialIn === null || dialIn === void 0 ? void 0 : dialIn.error) === null || _a === void 0 ? void 0 : _a.status) === StatusCode.PaymentRequired;
    // @ts-ignore
    const room = (_b = state["features/base/dialog"].componentProps) === null || _b === void 0 ? void 0 : _b.roomId;
    const roomCode = state["features/base/conference"].room;
    // @ts-ignore
    const isCodec = (_c = state["features/base/dialog"].componentProps) === null || _c === void 0 ? void 0 : _c.isCodec;
    // @ts-ignore
    const user = state["features/base/settings"].user;
    return {
        _dialIn: dialIn,
        _dialInVisible: isSharingEnabled(sharingFeatures.dialIn),
        _urlSharingVisible: isSharingEnabled(sharingFeatures.url),
        _emailSharingVisible: isSharingEnabled(sharingFeatures.email),
        _invitationText: getInviteText({ state, phoneNumber, t: ownProps.t }),
        _invitationTextiOS: getInviteTextiOS({
            state,
            phoneNumber,
            t: ownProps.t,
        }),
        _inviteAppName: inviteAppName,
        //  _inviteContactsVisible: interfaceConfig.ENABLE_DIAL_OUT && !hideInviteContacts,
        _inviteUrl: getInviteURL(state),
        _isDialInOverLimit: isDialInOverLimit,
        _liveStreamViewURL: currentLiveStreamingSession === null || currentLiveStreamingSession === void 0 ? void 0 : currentLiveStreamingSession.liveStreamViewURL,
        _phoneNumber: phoneNumber,
        _room: room,
        roomCode,
        isCodec,
        _user: user,
    };
}
/**
 * Maps dispatching of some action to React component props.
 *
 * @param {Function} dispatch - Redux action dispatcher.
 * @returns {IProps}
 */
const mapDispatchToProps = {
    updateNumbers: () => updateDialInNumbers(),
    sendUserList: sendIntoUserList,
};
export default translate(connect(mapStateToProps, mapDispatchToProps)(AddPeopleDialog));
